import { Loader2 } from "lucide-react";

export function PageLoader() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Loader2 className="size-8 animate-spin text-[#d4a574]" />
    </div>
  );
}
